const locale = {
  assistLabel: '您可能想输入：'
};
export default locale;